import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María G.',
    location: 'México',
    quote: 'Finalmente un método que no me abruma. Los cambios son reales.'
  }, {
    name: 'Ana L.',
    location: 'España',
    quote: 'En 21 días cambió mi forma de ver las cosas. Simple pero profundo.'
  }, {
    name: 'Sofía R.',
    location: 'Argentina',
    quote: 'No es magia, es constancia. Y funciona.'
  }];
  return <section className="py-12 bg-[#2B0A3D] text-white" data-id="element-178">
      <div className="max-w-6xl mx-auto px-4" data-id="element-179">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-180">
          Lo que dicen quienes ya lo hicieron
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-181">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 relative" data-id="element-182">
              <Quote className="w-8 h-8 text-[#D4AF37] mb-4 opacity-50" data-id="element-183" />
              <p className="text-lg font-light italic mb-6 text-white/90" data-id="element-184">
                "{t.quote}"
              </p>
              <div data-id="element-185">
                <p className="font-bold text-[#D4AF37]" data-id="element-186">{t.name}</p>
                <p className="text-sm text-white/50" data-id="element-187">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}